import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PageHeader from 'components/common/PageHeader';
import { fetchPartnerDashboard } from 'helpers/partners';

const PartnersDashboard = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const statCards = [
    { key: 'applications_count', title: t('PARTNERS.STATS.APPLICATIONS') },
    { key: 'joined_count', title: t('PARTNERS.STATS.JOINED') },
    { key: 'pending_count', title: t('PARTNERS.STATS.PENDING') }
  ];

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await fetchPartnerDashboard();
        setData(response);
      } catch (requestError) {
        setError(requestError.response?.data?.error || t('PARTNERS.ERROR_LOAD'));
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [t]);

  const signupLink = data?.partner?.signup_link
    ? `${window.location.origin}${data.partner.signup_link}`
    : '';

  const copyLink = async () => {
    if (!signupLink) return;
    await navigator.clipboard.writeText(signupLink);
  };

  if (loading) {
    return <div className="d-flex justify-content-center py-6"><Spinner animation="border" /></div>;
  }

  return (
    <>
      <PageHeader
        title={data?.partner?.label || t('PARTNERS.TITLE')}
        description={t('PARTNERS.DESCRIPTION')}
        className="mb-4"
      />

      {error ? <Alert variant="danger">{error}</Alert> : null}

      <Row className="g-3 mb-4">
        {statCards.map(card => (
          <Col md={4} key={card.key}>
            <Card className="h-100 border">
              <Card.Body>
                <div className="text-600 fs--1 mb-2">{card.title}</div>
                <div className="fs-2 fw-bold">{data?.stats?.[card.key] || 0}</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Card className="border">
        <Card.Body>
          <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
            <div>
              <h5 className="mb-2">{t('PARTNERS.LINK_TITLE')}</h5>
              <div className="text-700">{signupLink || t('PARTNERS.LINK_UNAVAILABLE')}</div>
              <div className="text-600 fs--1 mt-2">{t('PARTNERS.CODE', { code: data?.partner?.code || '-' })}</div>
            </div>
            <Button onClick={copyLink} disabled={!signupLink}>
              {t('PARTNERS.COPY_LINK')}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default PartnersDashboard;
